<template>
    <div>
        <b-sidebar id="sidebar-backdrop" class="sidebar-tire-tracker" :backdrop-variant="'dark'" :title="title" backdrop shadow :visible="allowAddRecord"
            :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('maintenanceShared.basic') }}</h3>
                    <b-col md="6" sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('addTireTracker.unitLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="recordPayload.unit_no" :options="nameOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchAssets"
                                :disabled="checkDisableStatus()">
                                <span slot="no-options">
                                    {{ $t('addTireTracker.searchUnit') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.unit_no" class="field-error">
                                {{ errors.unit_no[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col md="6" sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('maintenanceShared.type') }}:</label>
                            <b-form-select :disabled="checkDisableStatus()" @change="resetUnit()" class="f-12"
                                v-model="recordPayload.type" :options="typeOptions" />
                        </div>
                    </b-col>
                    <b-col md="12" v-if="recordPayload.type === 'Vehicle'">
                        <hr class="my-4" />
                        <h3 class="f-18 font-weight-bold text-left">{{ $t('addTireTracker.steerSection') }}</h3>
                        <b-row>
                            <b-col md="6" sm="12" class="mt-3">
                                <div class="text-left ">
                                    <label class="state">{{ $t('addTireTracker.steerL') }}</label>
                                    <b-form-select class="f-12"
                                        v-model="tiresData.Vehicle[0].tread_depth" :options="tiresOptions" />
                                </div>
                            </b-col>
                            <b-col md="6" sm="12" class="mt-3">
                                <div class="text-left select_arrow ">
                                    <label class="state">{{ $t('addTireTracker.steerR') }}</label>
                                    <b-form-select class="f-12"
                                        v-model="tiresData.Vehicle[1].tread_depth" :options="tiresOptions" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="12" class="mb-7rem">
                        <hr class="my-4" />
                        <h3 class="f-18 font-weight-bold text-left">{{ recordPayload.type === 'Vehicle' ? $t('addTireTracker.drive1') :
                            $t('addTireTracker.trailer1') }}</h3>
                        <b-row>
                            <b-col md="3" sm="12" class="mt-3"
                                v-for="(tire, index) in (recordPayload.type === 'Vehicle' ? tiresData.Vehicle.slice(2, 6) : tiresData.Trailer.slice(0, 4))"
                                :key="index">
                                <div class="text-left select_arrow">
                                    <label class="state">{{ tire.tire_position }}</label>
                                    <b-form-select class="f-12" v-model="tire.tread_depth" :options="tiresOptions" />
                                </div>
                            </b-col>
                        </b-row>
                        <h3 class="f-18 font-weight-bold text-left mt-4">{{ recordPayload.type === 'Vehicle' ? $t('addTireTracker.drive2') :
                            $t('addTireTracker.trailer2') }}</h3>
                        <b-row>
                            <b-col md="3" sm="12" class="mt-3"
                                v-for="(tire, index) in (recordPayload.type === 'Vehicle' ? tiresData.Vehicle.slice(6, 10) : tiresData.Trailer.slice(4, 8))"
                                :key="index">
                                <div class="text-left select_arrow">
                                    <label class="state">{{ tire.tire_position }}</label>
                                    <b-form-select class="f-12" v-model="tire.tread_depth" :options="tiresOptions" />
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mx-0 h-40px w-100px" :class="hasChanged ? 'mr-3':''" @click="resetPopup()" variant="secondary">{{ $t('maintenanceShared.close') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px" v-if="hasChanged" @click="addAndUpdateTireTrackerData()"
                        variant="primary">{{ $t('maintenanceShared.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import vSelect from 'vue-select';
import { checkValueExists } from "@/services/helper";
import 'vue-select/dist/vue-select.css';
export default {
    name: "AddAndUpdateTireTracker",
    components: {
        vSelect
    },
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        allowAddRecord: {
            type: Boolean,
            default: false
        },
        tiresRecordData: {
            type: [Object],
            default: null,
        }
    },
    computed: {
        hasChanged() {
            const payloadChanged = Object.keys(this.recordPayload).filter(field => {
                if (!this.recordPayload[field] && !this.defaultData[field]) return false;
                return this.checkValueExists(this.recordPayload[field]) != this.checkValueExists(this.defaultData[field]);
            }).length > 0;
            
            // Check if tires data changed - compare based on current type
            const currentTires = JSON.stringify(this.tiresData[this.recordPayload.type]);
            const defaultTires = JSON.stringify(this.defaultData.tires_info);
            const tiresChanged = currentTires !== defaultTires;
            
            return payloadChanged || tiresChanged;
        },
        title() {
            return this.allowEditTask || this.tiresRecordData ? this.getTitle() : this.$t('tireTracker.addRecord')
        },
        typeOptions() {
            return [
                { value: 'Vehicle', text: this.$t('maintenanceShared.vehicle') },
                { value: 'Trailer', text: this.$t('maintenanceShared.trailer') },
            ];
        },
    },
    data() {
        return {
            checkValueExists,
            allowEditTask: false,
            nameOptions: [],
            defaultData: {
                unit_no: null,
                type: 'Vehicle',
                tires_info: [
                    { "tire_position": "Steer L", "tread_depth": 0 },
                    { "tire_position": "Steer R", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Outer", "tread_depth": 0 }
                ]
            },
            errors: {},
            recordPayload: {
                unit_no: null,
                type: 'Vehicle'
            },
            tiresOptions: [
                {
                    value: 0,
                    text: '0/32'
                },
                {
                    value: 1,
                    text: '1/32'
                },
                {
                    value: 2,
                    text: '2/32'
                },
                {
                    value: 3,
                    text: '3/32'
                },
                {
                    value: 4,
                    text: '4/32'
                },
                {
                    value: 5,
                    text: '5/32'
                },
                {
                    value: 6,
                    text: '6/32'
                },
                {
                    value: 7,
                    text: '7/32'
                },
                {
                    value: 8,
                    text: '8/32'
                },
                {
                    value: 9,
                    text: '9/32'
                },
                {
                    value: 10,
                    text: '10/32'
                },
                {
                    value: 11,
                    text: '11/32'
                },
                {
                    value: 12,
                    text: '12/32'
                },
                {
                    value: 13,
                    text: '13/32'
                },
                {
                    value: 14,
                    text: '14/32'
                },
                {
                    value: 15,
                    text: '15/32'
                },
                {
                    value: 16,
                    text: '16/32'
                },
                {
                    value: 17,
                    text: '17/32'
                },
                {
                    value: 18,
                    text: '18/32'
                },
                {
                    value: 19,
                    text: '19/32'
                },
                {
                    value: 20,
                    text: '20/32'
                },
                {
                    value: 21,
                    text: '21/32'
                },
                {
                    value: 22,
                    text: '22/32'
                },
                {
                    value: 23,
                    text: '23/32'
                },
                {
                    value: 24,
                    text: '24/32'
                },
                {
                    value: 25,
                    text: '25/32'
                },
                {
                    value: 26,
                    text: '26/32'
                },
                {
                    value: 27,
                    text: '27/32'
                },
                {
                    value: 28,
                    text: '28/32'
                },
                {
                    value: 29,
                    text: '29/32'
                },
                {
                    value: 30,
                    text: '30/32'
                },
                {
                    value: 31,
                    text: '31/32'
                },
                {
                    value: 32,
                    text: '32/32'
                }
            ],
            tiresData: {
                Vehicle: [
                    { "tire_position": "Steer L", "tread_depth": 0 },
                    { "tire_position": "Steer R", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Outer", "tread_depth": 0 }

                ],
                Trailer: [
                    { "tire_position": "Trailer 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 R Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 R Inner", "tread_depth": 0 }

                ]
            }
        }
    },
    watch: {
        id: {
            async handler(newVal) {
                if (newVal) {
                    try {
                        this.setLoader(true);
                        const data = await this.getTireTrackerData({ equipID: newVal });
                        this.recordPayload.type = data.unit_info.type;
                        this.tiresData[this.recordPayload.type] = data.tires_info;
                        this.allowEditTask = true
                        this.recordPayload.unit_no = data.unit_info.id
                        this.nameOptions = [{
                            id: data.unit_info.id,
                            label: data.unit_info.unit_no,
                        }]
                        this.defaultData = JSON.parse(JSON.stringify({...this.recordPayload, tires_info: this.tiresData[this.recordPayload.type]}))
                        this.setLoader(false);
                    } catch (error) {
                        this.setLoader(false);
                        console.log(error);
                    }
                }
            },
            immediate: true,
        },
        tiresRecordData: {
            async handler(newVal) {
                if (newVal) {
                    this.recordPayload.unit_no = newVal.id
                    this.recordPayload.type = newVal.type;
                    this.nameOptions = [{
                        id: newVal.id,
                        label: newVal.unit_no,
                    }]
                    this.defaultData = JSON.parse(JSON.stringify({...this.recordPayload, tires_info: this.tiresData[this.recordPayload.type]}))
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ...mapActions(["getFilteredEquipments", "setNotification", "setLoader", "addTireTrackerData", "getTireTrackerData", "updateTireTrackerData"]),
        checkDisableStatus(){
            return this.allowEditTask || Object.keys({} || this.tiresRecordData).length > 0
        },
        getTitle() {
            const selectedOption = this.nameOptions.find(option => option.id === this.recordPayload.unit_no);
            return selectedOption ? selectedOption.label : '';
        },
        resetUnit() {
            this.recordPayload.unit_no = null;
            this.nameOptions = [];
            this.tiresData = {
                Vehicle: [
                    { "tire_position": "Steer L", "tread_depth": 0 },
                    { "tire_position": "Steer R", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Outer", "tread_depth": 0 }

                ],
                Trailer: [
                    { "tire_position": "Trailer 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 R Outer", "tread_depth": 0 },
                    { "tire_position": "Trailer 2 R Inner", "tread_depth": 0 }

                ]
            }
        },
        resetPopup() {
            this.$emit('close');
            this.recordPayload = {
                unit_no: null,
                type: 'Vehicle'
            };
            this.errors = {};
            this.allowEditTask = false;
            this.nameOptions = [];
            this.resetUnit();
            this.defaultData = {
                unit_no: null,
                type: 'Vehicle',
                tires_info: [
                    { "tire_position": "Steer L", "tread_depth": 0 },
                    { "tire_position": "Steer R", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 1 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 1 R Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Outer", "tread_depth": 0 },
                    { "tire_position": "Drive 2 L Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Inner", "tread_depth": 0 },
                    { "tire_position": "Drive 2 R Outer", "tread_depth": 0 }
                ]
            };
        },
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText, type: this.recordPayload.type, status: null, noTireRecords: true });
                equipmentRecords.map((item) => {
                    options.push({
                        id: `${item.id}`,
                        label: item.unit_no,
                    });
                });
                this.nameOptions = options
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (key === 'record_ids' && this.recordPayload.record_choice === 'Select') {
                    if (value.length === 0) {
                        nullKeys.push(key);
                    }
                }
                else {
                    if (!value) {
                        nullKeys.push(key);
                    }
                }
            }
            return nullKeys;
        },
        async addAndUpdateTireTrackerData() {
            try {
                this.setLoader(true)
                const nullKeys = this.checkNullValues({
                    unit_no: this.recordPayload.unit_no,
                    type: this.recordPayload.type,
                });
                if (nullKeys.length === 0) {
                    const payload = {
                        equipID: this.recordPayload.unit_no,
                        tires: this.tiresData[this.recordPayload.type]
                    }
                    if (this.allowEditTask) {
                        await this.updateTireTrackerData(payload)
                    }
                    else await this.addTireTrackerData(payload)
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.allowEditData ? this.$t('addTireTracker.updated') : this.$t('addTireTracker.added'),
                        type: "success",
                        color: "green",
                    });
                    this.$emit('tiresDataUpdated')
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('maintenanceShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    }
}
</script>